/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-08-02 10:38:33
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-19 11:24:02
 */
import request from '@/utils/request'
import type * as dd from '@/typings/dd'

// DD - 编辑DD/新建DD
export async function editPmdd(params: dd.DdEditParams) {
  return request('/api/v2/project/pipeline/dd/edit', {
    method: 'post',
    data: params
  })
}

interface IConfirmPmddRequest {
  memo_id: number
  confirm_stage: number
}
// DD - 确认DD（PM Confirm / Sponsor Confirm）
export async function confirmPmdd(params: IConfirmPmddRequest) {
  return request('/api/v2/project/pipeline/dd/confirm', {
    method: 'post',
    data: params
  })
}

interface IOpenAllDdRequest {
  memo_id: number
}
// 开启所有DD（针对历史DD数据调用的接口）
export async function openAllDd(params: IOpenAllDdRequest) {
  return request('/api/v2/project/pipeline/dd/add_all', {
    method: 'post',
    data: params
  })
}

interface IOpenDdRequest {
  memo_id: number
}
// 开启所有DD（针对历史DD数据调用的接口）
export async function openDd(params: IOpenDdRequest) {
  return request('/api/v2/project/pipeline/dd/open', {
    method: 'post',
    data: params
  })
}

interface IUpdateDDPlanRequest {
  memo_id: number
  items: dd.DdPlanItemInfo[]
}
// 编辑DDPlan表单
export async function updateDDPlan(params: IUpdateDDPlanRequest) {
  return request('/api/v2/project/pipeline/dd/plan/update', {
    method: 'post',
    data: params
  })
}

interface IConfirmDDPlanRequest {
  memo_id: number
}
// DDPlan流程轴Sponsor Confirm
export async function confirmDDPlan(params: IConfirmDDPlanRequest) {
  return request('/api/v2/project/pipeline/dd/plan/sponsor_confirm', {
    method: 'post',
    data: params
  })
}
